const getDefaultSchedule = () => {
  if (typeof window !== 'undefined' && typeof window.requestAnimationFrame === 'function') {
    return window.requestAnimationFrame.bind(window);
  }

  return (callback) => callback();
};

export const scrollAttendanceResultsIntoView = (attendanceResultsRef) => {
  const node = attendanceResultsRef?.current;

  if (!node || typeof node.scrollIntoView !== 'function') {
    return false;
  }

  node.scrollIntoView({
    behavior: 'smooth',
    block: 'start',
  });

  return true;
};

export const scheduleAttendanceResultsScroll = (
  attendanceResultsRef,
  schedule = getDefaultSchedule()
) => {
  schedule(() => scrollAttendanceResultsIntoView(attendanceResultsRef));
};

export const createAttendanceViewModeChangeHandler = ({
  setAttendanceViewMode,
  attendanceResultsRef,
  schedule,
}) => (mode) => {
  setAttendanceViewMode(mode);
  scheduleAttendanceResultsScroll(attendanceResultsRef, schedule);
};
